import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
import { RouteComponentProps } from 'react-router';
import * as SharedMaterialsManagementStateController from '../../store/StateControllers/SharedMaterials/SharedMaterialsManagementStateController';
import * as Models from '../../store/Models/SharedMaterials/DataModel';
import * as Table from '../core/ToxnotReactTable';
import { ToxnotReactComponentPaths } from '../core/ToxnotReactComponentPaths';
import { AppServices } from '../../AppServices';

import './AccessRequestInbox.css';
import { ToxnotComponentProperties } from '../core/BaseApplicationComponents/ToxnotComponent';
import { ToxnotSignInRequiredComponent } from '../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';

type AccessRequestInboxProps =
    typeof SharedMaterialsManagementStateController.actionCreators &
    SharedMaterialsManagementStateController.ManagementState &
    ToxnotComponentProperties &
    RouteComponentProps;

class AccessRequestInbox extends ToxnotSignInRequiredComponent<AccessRequestInboxProps>{
    // ===============================================================================

    public componentDidMount() {
        this.props.getAllAccessRequests();
    }

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [];
    }

    // ===============================================================================

    protected renderConcreteComponent() {
        const accessRequestInboxCols: Table.TableColumn<Models.SharedMaterialsAccessRequestCatalogRequest>[] = [
            {
                value: this.localizeString("Requestor")
            },
            {
                value: this.localizeString("Requested Materials")
            },
            {
                value: this.localizeString("Date Requested")
            },
            {
                value: null
            },
        ];

        return (
            <div className="tn-section">
                <div className="tn-section-row tn-section-heading-row">
                    <div className="tn-section-col-12">
                        <h1>{this.localizeString("Access Requests")}</h1>
                    </div>
                </div>
                <div className="tn-section-row">
                    <div id="response-status-container" className="tn-section-col-12">
                        {this.props.accessRequestInboxState.respondingToRequestsState === SharedMaterialsManagementStateController.ManagementOperationBaseStates.OperationStarted && <div className="alert alert-info">{this.localizeString("Responding...")}</div>}
                        {this.props.accessRequestInboxState.respondingToRequestsState === SharedMaterialsManagementStateController.ManagementOperationBaseStates.OperationCompleted && <div className="alert alert-success">{this.localizeString("Responded successfully to request!")}</div>}
                        {this.props.accessRequestInboxState.respondingToRequestsState === SharedMaterialsManagementStateController.ManagementOperationBaseStates.OperationFailed && <div className="alert alert-danger">{this.localizeString("Sorry, there was a problem responding to this request.")}</div>}
                    </div>
                </div>
                <div className="tn-section-row">
                    <div className="tn-section-col-12">
                        {this.props.accessRequestInboxState.isLoading
                            ? <div>{this.localizeString("Loading...")}</div>
                            : <Table.ToxnotReactTable<Models.SharedMaterialsAccessRequestCatalogRequest> allRowModels={this.props.accessRequestInboxState.catalog.accessRequests} headerRow={accessRequestInboxCols} getRowForTable={this.createRowData} localizer={this.props.appServices}/>}
                    </div>
                </div>
                <div className="tn-section-row">
                    <div className="tn-section-col-12">
                        <a href={ToxnotReactComponentPaths.MyPassports} className="btn btn-toxnot-primary">{this.localizeString("Done")}</a>
                    </div>
                </div>
            </div>
        );
    }

    // ===============================================================================

    private createRowData = (request: Models.SharedMaterialsAccessRequestCatalogRequest, rowIndex: number): Table.TableRow => {
        return (
            {
                cols: [
                    <span>{request.requestorName} (<a href={"mailto: " + request.requestorEmail}>{request.requestorEmail}</a>)</span>,
                    request.sharedMaterialIds.map((id, index) => <Link key={index} to={ToxnotReactComponentPaths.SharedMaterialBaseDetailPath + "/" + id}>{this.props.accessRequestInboxState.catalog.allSharedMaterialsCoreDataMap[id]?.materialName ?? this.localizeString("Unknown Material")}</Link>).reduce((prev, curr) => <span>{prev}, {curr}</span>),
                    new Date(request.dateSent).toLocaleDateString(),
                    (<div className="requests-action-buttons-container">
                        <button className="btn btn-default .approve-request-button" onClick={e => this.respondToRequestButton_click(request.requestId, Models.AccessRequestResponseType.Approved)}>
                            <span className="glyphicon glyphicon-ok approve-request"/>
                        </button>
                        <button className="btn btn-default .decline-request-button" onClick={e => this.respondToRequestButton_click(request.requestId, Models.AccessRequestResponseType.Declined)}>
                            <span className="glyphicon glyphicon-remove decline-request" />
                        </button>
                    </div>)
                ]
            } as Table.TableRow
        );
    }

    // ===============================================================================
    //
    // UI Event Handlers
    //
    // ===============================================================================

    private respondToRequestButton_click = (requestId: string, type: Models.AccessRequestResponseType ): void => {
        this.props.respondToAccessRequest(requestId, type);
    }
}

export default connect(
    (state: ApplicationState) => ({ ...state.sharedMaterialsManagementState, appServices: state.appServices}),
    SharedMaterialsManagementStateController.actionCreators // Selects which action creators are merged into the component's props
)(AccessRequestInbox as any);